import styled from 'styled-components';
import { Divider as AntdDivider } from 'antd';
import { DividerProps as AntdDividerProps } from 'antd/lib/divider';

export type DividerProps = AntdDividerProps;

export const Divider = styled(AntdDivider)``;
export default Divider;
